import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
    Stack,
    Alert,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip
} from '@mui/material';
import api from '../../api/axios';

const EmployeeMissedPunch = () => {

    const [attendanceDate, setAttendanceDate] = useState('');
    const [clockIn, setClockIn] = useState('');
    const [clockOut, setClockOut] = useState('');
    const [reason, setReason] = useState('');
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [requests, setRequests] = useState([]);

    /* ================= LOAD ================= */
    const loadMyRequests = async () => {
        try {
            const res = await api.get('/missed-punch/employee');
            console.log("API DATA:", res.data); // DEBUG
            setRequests(res.data);
        } catch (e) {
            console.error(e);
            setError('Failed to load requests');
        }
    };

    useEffect(() => {
        loadMyRequests();
    }, []);

    /* ================= SUBMIT ================= */
    const submitRequest = async () => {
        setError('');
        setSuccess('');

        if (!attendanceDate) return setError('Select date');
        if (!clockIn && !clockOut) return setError('Enter time');
        if (!reason.trim()) return setError('Reason required');

        let punchType = 'BOTH';
        if (clockIn && !clockOut) punchType = 'CLOCK_IN';
        if (!clockIn && clockOut) punchType = 'CLOCK_OUT';

        try {
            await api.post('/missed-punch/request', null, {
                params: {
                    punchType,
                    clockIn: clockIn ? `${attendanceDate}T${clockIn}` : null,
                    clockOut: clockOut ? `${attendanceDate}T${clockOut}` : null,
                    reason
                }
            });

            setSuccess('Request submitted');
            setAttendanceDate('');
            setClockIn('');
            setClockOut('');
            setReason('');
            loadMyRequests();

        } catch (e) {
            console.error(e);
            setError('Submit failed');
        }
    };

    /* ================= STATUS COLOR ================= */
    const statusColor = (status) => {
        if (status === 'APPROVED') return 'success';
        if (status === 'REJECTED') return 'error';
        return 'warning';
    };

    /* ================= UI ================= */
    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" fontWeight={700} mb={3}>
                Missed Punch Request
            </Typography>

            {/* FORM */}
            <Paper sx={{ p: 3, mb: 4 }}>
                <Stack spacing={2}>

                    {success && <Alert severity="success">{success}</Alert>}
                    {error && <Alert severity="error">{error}</Alert>}

                    <TextField
                        type="date"
                        label="Date"
                        InputLabelProps={{ shrink: true }}
                        value={attendanceDate}
                        onChange={(e) => setAttendanceDate(e.target.value)}
                    />

                    <Stack direction="row" spacing={2}>
                        <TextField
                            type="time"
                            label="Clock In"
                            InputLabelProps={{ shrink: true }}
                            value={clockIn}
                            onChange={(e) => setClockIn(e.target.value)}
                            fullWidth
                        />
                        <TextField
                            type="time"
                            label="Clock Out"
                            InputLabelProps={{ shrink: true }}
                            value={clockOut}
                            onChange={(e) => setClockOut(e.target.value)}
                            fullWidth
                        />
                    </Stack>

                    <TextField
                        label="Reason"
                        multiline
                        rows={3}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />

                    <Button
                        variant="contained"
                        sx={{ bgcolor: '#2563eb' }}
                        onClick={submitRequest}
                    >
                        Submit Request
                    </Button>

                </Stack>
            </Paper>

            {/* TABLE */}
            <Typography variant="h6" mb={2}>
                My Requests
            </Typography>

            <Paper>
                <Table>
                    <TableHead sx={{ backgroundColor: '#f1f5f9' }}>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Clock In</TableCell>
                            <TableCell>Clock Out</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {requests.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    No requests found
                                </TableCell>
                            </TableRow>
                        ) : (
                            requests.map((r) => (
                                <TableRow key={r.attendanceId}>
                                    <TableCell>{r.date}</TableCell>
                                    <TableCell>{r.requestedClockIn || '-'}</TableCell>
                                    <TableCell>{r.requestedClockOut || '-'}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={r.status}
                                            color={statusColor(r.status)}
                                            size="small"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    );
};

export default EmployeeMissedPunch;